import {
  EventModality,
  OpportunityType,
  ContactRecruitingPattern,
} from '../types/api/opportunities.js';

export const OPPORTUNITY_TYPE_LABELS: Record<OpportunityType, string> = {
  [OpportunityType.JOB_OFFER]: "Offres d'emploi",
  [OpportunityType.EVENT]: 'Événements',
  [OpportunityType.CONTACT]: 'Contacts',
};

export const EVENT_MODALITY_LABELS: Record<EventModality, string> = {
  [EventModality.PRESENTIEL]: 'Présentiel',
  [EventModality.DISTANCIEL]: 'Distanciel',
  [EventModality.MIXTE]: 'Mixte',
};

export const CONTACT_RECRUITING_PATTERNS_LABELS: Record<ContactRecruitingPattern, string> = {
  [ContactRecruitingPattern.RECRUIT_REGULARLY]: 'Recrute régulièrement',
  [ContactRecruitingPattern.SHARE_EXPERTISE]: 'Partage son expertise',
  [ContactRecruitingPattern.WELCOME_PMSMP]: 'Accueille en PMSMP',
};

export type ProsaisieApiType = 'JobOffer' | 'Event' | 'Contact';

export const PROSAISIE_TYPE_BY_OPPORTUNITY_TYPE: Record<OpportunityType, ProsaisieApiType> = {
  [OpportunityType.JOB_OFFER]: 'JobOffer',
  [OpportunityType.EVENT]: 'Event',
  [OpportunityType.CONTACT]: 'Contact',
};
